module.exports = __webpack_public_path__ + "img/bonus2.23b2d553.png";